import { useTranslation } from 'react-i18next'
import { toggleLang } from '../i18n'

export default function LangToggle() {
  const { t, i18n } = useTranslation()
  return (
    <button
      className="btn btn-ghost btn-sm"
      title={t('lang.title')}
      onClick={() => toggleLang()}
    >
      {i18n.language === 'zh' ? 'EN' : '中文'}
    </button>
  )
}
